export const SectionHeader = ({ index, title, sub, testId }) => {
  return (
    <div className="mb-12 md:mb-16" data-testid={testId}>
      <div className="flex items-baseline gap-4">
        <span className="font-mono text-xs text-purple-400 tracking-widest">
          {index}
        </span>
        <div className="flex-1 h-px bg-gradient-to-r from-purple-500/40 via-white/10 to-transparent" />
      </div>
      <h2 className="mt-4 text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight text-white">
        {title}
        <span className="text-purple-400">.</span>
      </h2>
      {sub && (
        <p className="mt-3 max-w-2xl text-white/60 text-base md:text-lg">
          {sub}
        </p>
      )}
    </div>
  );
};
